import { Button, Footer, Logo, OptiBlocking } from '~/shared/ui'

/** Confluence page describing how to request access to Opti. */
const ACCESS_INSTRUCTIONS_URL =
  'http://go.confluence.natera.com/wiki/spaces/UEG/pages/361893456/Optistream+User+Access+Access+Request+Guide'

interface LoginErrorPageProps {
  /** Error surfaced by Okta's LoginCallback (e.g. "User is not assigned to the client application"). */
  error?: Error
}

/**
 * Rendered when Okta rejects the sign-in itself — typically because the user is not
 * assigned to the Opti client application — so authentication never completes and no
 * token is issued. Instead of dumping the raw OAuth error, this shows a friendly message
 * and points the user to the access-request instructions. It does not redirect anyone.
 */
export function LoginErrorPage(_props: LoginErrorPageProps) {
  return (
    <div className="relative flex h-screen min-h-[768px] min-w-[1280px] flex-col">
      <header className="flex h-[72px] items-center px-6">
        <Logo />
      </header>
      <div className="flex-1">
        <div className="absolute top-1/2 left-1/2 flex w-[460px] -translate-1/2 flex-col items-center rounded-lg px-6 py-8 shadow-[0px_3px_13px_0px_rgba(0,0,0,0.04),0px_10.5px_36px_0px_rgba(0,0,0,0.19)]">
          <div className="mt-1">
            <OptiBlocking />
          </div>
          <div className="mt-3 text-xl leading-6 font-medium tracking-[0.15px]">
            Access required
          </div>
          <div className="text-text-secondary mt-2 text-center text-[17px] leading-6 tracking-[0.5px]">
            You don&apos;t have access to Opti yet. Follow the instructions to request access, then
            sign in again.
          </div>
          <div className="mt-8 mb-2 flex w-full flex-col gap-2 px-6">
            <Button
              className="w-full"
              size="large"
              raised
              materialIcon="open_in_new"
              onClick={() => window.open(ACCESS_INSTRUCTIONS_URL, '_blank', 'noopener,noreferrer')}
            >
              View access instructions
            </Button>
            <Button
              className="w-full"
              size="large"
              tonal
              materialIcon="login"
              onClick={() => window.location.assign('/login')}
            >
              Back to sign in
            </Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
